import { useReducer } from 'react'

import AITripSearchState, {
  AI_TRIP_SEARCH_INITIAL_STATE,
  aiTripSearchStateReducer,
} from 'tripPlanner/contexts/Search/AITripSearchState'

export default function useAITripSearchContext(
  initialState: AITripSearchState = AI_TRIP_SEARCH_INITIAL_STATE,
) {
  const [aiTripSearchState, aiTripSearchDispatch] = useReducer(
    aiTripSearchStateReducer,
    initialState,
  )

  return { aiTripSearchState, aiTripSearchDispatch }
}
